import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type ReimaginedDataService from 'tio-employee/services/reimagined-data';

export default class CareerPathwaysPslfVaultIndexRoute extends Route {
  @service declare reimaginedData: ReimaginedDataService;

  async model() {
    const vault = await this.reimaginedData.fetchPslfVault();
    return { vault };
  }
}
